import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import { Stack } from "@mui/material";
import { AdminDeleteIcon, AdminEditIcon, ViewIcon } from "../../@lib/icons";
import { useState } from "react";
import { MdArrowDownward, MdArrowUpward } from "react-icons/md";
import { ConditionalRenderer } from "../conditionalRenderer";

function MUITable({
  data = [],
  columns = [],
  moduleKey,
  onClickHandler = () => {},
  totalPages = undefined,
  rowsPerPage,
  page,
  setRowsPerPage,
  setPage,
  isView,
}: any) {
  const [sortColumn, setSortColumn] = useState<string | null>(null);
  const [sortOrder, setSortOrder] = useState<"asc" | "desc">("asc");

  const handleChangePage = (event: any, newPage: any) => {
    setPage(newPage + 1);
  };

  const handleChangeRowsPerPage = (event: any) => {
    setRowsPerPage(+event.target.value);
    setPage(1);
  };

  const handleSort = (columnId: string) => {
    let newSortOrder: "asc" | "desc" = "asc";
    if (sortColumn === columnId && sortOrder === "asc") {
      newSortOrder = "desc";
    }
    setSortColumn(columnId);
    setSortOrder(newSortOrder);
  };

  const sortedData = [...data]?.sort((a, b) => {
    if (!sortColumn) return 0;
    const valA = a[sortColumn];
    const valB = b[sortColumn];

    if (typeof valA === "number" && typeof valB === "number") {
      return sortOrder === "asc" ? valA - valB : valB - valA;
    }
    return sortOrder === "asc"
      ? String(valA).localeCompare(String(valB))
      : String(valB).localeCompare(String(valA));
  });

  return (
    <Paper sx={{ width: "100%", overflow: "hidden" }}>
      <TableContainer sx={{ height: "100%" }}>
        <Table>
          <TableHead>
            <TableRow>
              {columns?.map((column: any) => (
                <TableCell
                  key={`MUItable-${moduleKey}-${column.id}`}
                  align={column.align}
                  onClick={() => handleSort(column.id)}
                  sx={{ cursor: "pointer", userSelect: "none" }}
                >
                  {column.label}
                  <ConditionalRenderer condition={column.label !== "Action"}>
                    {sortColumn === column.id ? (
                      sortOrder === "asc" ? (
                        <MdArrowUpward fontSize="small" />
                      ) : (
                        <MdArrowDownward fontSize="small" />
                      )
                    ) : (
                      <MdArrowUpward
                        fontSize="small"
                        style={{ opacity: 0.5 }}
                      />
                    )}
                  </ConditionalRenderer>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedData?.map((row: any, rowIndex: any) => {
              return (
                <TableRow
                  key={`tabelRow-${moduleKey}-${rowIndex}`}
                  hover
                  role="checkbox"
                  tabIndex={-1}
                >
                  {columns?.map((column: any, columnIndex: any) => {
                    if (column.id === "id") {
                      const value = row[column.id];
                      return (
                        <TableCell
                          key={`tableCell-buttons-${moduleKey}-${columnIndex}`}
                          align={column.align}
                        >
                          <Stack direction={"row"} justifyContent={"flex-end"}>
                            <ConditionalRenderer condition={isView}>
                              <button
                                onClick={() => onClickHandler("view", row)}
                                style={{
                                  backgroundColor: "transparent",
                                  border: "0px",
                                  cursor: "pointer",
                                }}
                              >
                                <ViewIcon />
                              </button>
                            </ConditionalRenderer>
                            <button
                              onClick={() => onClickHandler("edit", value)}
                              style={{
                                backgroundColor: "transparent",
                                border: "0px",
                                cursor: "pointer",
                              }}
                            >
                              <AdminEditIcon />
                            </button>
                            <button
                              onClick={() => onClickHandler("delete", value)}
                              style={{
                                backgroundColor: "transparent",
                                border: "0px",
                                cursor: "pointer",
                              }}
                            >
                              <AdminDeleteIcon />
                            </button>
                          </Stack>
                        </TableCell>
                      );
                    }

                    const value = row[column.id];
                    return (
                      <TableCell
                        key={`tableCell-${moduleKey}-${column.id}`}
                        align={column.align}
                        title={value}
                        sx={{ fontWeight: column.id === "sr" ? "700" : "400" }}
                      >
                        {value}
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        // rowsPerPageOptions={[10, 25, 100]}
        rowsPerPageOptions={[]}
        component="div"
        count={totalPages ? totalPages * rowsPerPage : data?.length}
        rowsPerPage={10}
        // page={page}
        page={page - 1}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
}

export { MUITable };
